import apiClient from "./client";

export async function getBillingInfo() {
  const res = await apiClient.get("/api/billing");
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}

export async function initiatePayment(companyId, planLimit) {
  const res = await apiClient.post("/api/payments/initiate", {
    company_id: companyId,
    newPlanLimit: planLimit,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || "Помилка ініціації платежу");
  }
  return res;
}
